import Selection from "components/Input/Selection/Selection";
import React from 'react'
import { Controller } from "react-hook-form";
import { formBuilderParams } from "../FormBuilder";
import { formRulesBuilder } from "../lib/FormBuilderRules";
import { useDefaultValueTriggerUpdate, useRemoveMandatoryError } from "../Utils/FormBuilderUtils";

/**
 * @typedef {import("../lib/FormBuilderFieldBuilder").baseFormComponentProps} baseFormComponentProps
 * @typedef {import("../lib/FormBuilderFieldBuilder").baseConfig} baseConfig
 * @typedef {import("../lib/FormBuilderFieldBuilder").selectionConfig} selectionConfig
 * @param {baseFormComponentProps & baseConfig & selectionConfig} props
 */
const FormBuilderSelection = ({
  formProps,
  fieldName,
  defaultValue,
  defaultValueTriggerUpdate = false,
  mandatory = false,
  dependents = [],
  rules,
  customRule,
  label,
  subLabel,
  hideLabel,
  noErrorMessage = false,
  options = [],
  multiSelection = false,
  placeholder = "",
  customOnChangeFn,
  disabled = false,
  readOnly = false,
}) => {
  useRemoveMandatoryError({ fieldName, mandatory, formProps });
  defaultValueTriggerUpdate && useDefaultValueTriggerUpdate({ fieldName, defaultValue, formProps });

  return (
    <Controller
      key={fieldName}
      name={fieldName}
      control={formProps.control}
      defaultValue={defaultValue ?? (multiSelection ? [] : null)}
      rules={formRulesBuilder({ mandatory, dependents, rules, customRule })}
      render={({ field: { value, onChange, ref, name }, fieldState: { error } }) => (
        <Selection
          inputRef={ref}
          name={name}
          label={label}
          subLabel={subLabel}
          hideLabel={hideLabel === "removePadding"}
          emptyLabel={hideLabel === "keepPadding"}
          noErrorMessage={noErrorMessage}
          options={options}
          multiple={multiSelection}
          clearable={!mandatory}
          placeholder={placeholder}
          selectionValue={multiSelection ? (Array.isArray(value) ? value : []) : value}
          onchangeFn={(e) => {
            const newValue = e.target.value;
            onChange(newValue);
            if (customOnChangeFn) customOnChangeFn(newValue, formProps);
          }}
          errorMessage={error?.message || ""}
          sxParams={{
            selectionError: !!error,
          }}
          divStyle={formBuilderParams.formItemStyle}
          disabled={disabled}
          readOnly={readOnly}
          mandatory={mandatory}
        />
      )}
    />
  );
}

export default FormBuilderSelection;